import { withInstall } from '@lit-element/utils'
import Cascader from './src/cascader.vue'
import type { SFCWithInstall } from '@lit-element/utils'

export const LtCascader: SFCWithInstall<typeof Cascader> = withInstall(Cascader)

export default LtCascader

export * from './src/cascader'
export * from './src/instances'
